import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INotificationList } from '@shared/models/notification';
import { BehaviorSubject, catchError, Observable, retry } from 'rxjs';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private notificationEnabledSubject = new BehaviorSubject<boolean>(false);
    notificationEnabled$ = this.notificationEnabledSubject.asObservable();

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService,
        private apiSerice: ApiService,
    ) {}

    get apiUrl(): string {
        return this.configService.apiEndpoint;
    }

    setNotificationEnabled(value: boolean): void {
        this.notificationEnabledSubject.next(value);
    }

    /**
     * Returns list of notifications
     */
    getNotificationList(): Observable<INotificationList> {
        return this.httpClient.get<INotificationList>(`${this.apiUrl}/me/notifications`).pipe(retry(1), catchError(this.apiSerice.httpErrorHandler));
    }

    /**
     * Sends the BE notification when notification are read
     */
    postNotificationList(requestBody: any) {
        return this.httpClient.post(`${this.apiUrl}/me/notifications`, requestBody).pipe(catchError(this.apiSerice.httpErrorHandler));
    }

    /**
     * Service call for Saving Notification Preference under User Profile Section
     */
    putNotifications(requestBody: any) {
        return this.httpClient.put(`${this.apiUrl}/me/notification-preference`, requestBody).pipe(retry(1), catchError(this.apiSerice.httpErrorHandler));
    }
}
